import React from 'react';
import { useLedger } from '../hook/useLedger'; // Import your custom hook

const LedgerDetails = ({ entries = [] }) => {
  // Use the hook to extract calculated values cleanly
  const { totalBalance, totalDebit, totalCredit, ledgerEntries } = useLedger(entries);

  return (
    <div className="my-4">
      {/* Top Card: Total Balance */}
      <div className="row g-3 mb-4">
        {/* Card 1: Total Balance */}
        <div className="col-md-4">
          <div className="card text-center h-100 border-primary shadow-sm">
            <div className="card-body">
              <h6 className="card-title text-muted text-uppercase small fw-bold">Total Balance</h6>
              <h3 className={`fw-bold ${totalBalance >= 0 ? 'text-success' : 'text-danger'}`}>
                {totalBalance.toFixed(2)}
              </h3>
            </div>
          </div>
        </div>

        {/* Card 2: Total Credits */}
        <div className="col-md-4">
          <div className="card text-center h-100 border-success shadow-sm">
            <div className="card-body">
              <h6 className="card-title text-muted text-uppercase small fw-bold">Total Credit (+)</h6>
              <h3 className="fw-bold text-success">
                {totalCredit.toFixed(2)}
              </h3>
            </div>
          </div>
        </div>

        {/* Card 3: Total Debits */}
        <div className="col-md-4">
          <div className="card text-center h-100 border-danger shadow-sm">
            <div className="card-body">
              <h6 className="card-title text-muted text-uppercase small fw-bold">Total Debit (-)</h6>
              <h3 className="fw-bold text-danger">
                {totalDebit.toFixed(2)}
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Ledger Table */}
      <div className="card shadow-sm">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th scope="col" className="ps-3">Date & Time</th>
                <th scope="col">Voucher Type</th>
                <th scope="col">Voucher No</th>
                <th scope="col" className="text-end">Debit (-)</th>
                <th scope="col" className="text-end">Credit (+)</th>
                <th scope="col" className="text-end pe-3">Running Balance</th>
              </tr>
            </thead>
            <tbody>
              {ledgerEntries.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center py-4 text-muted">
                    No transactions found.
                  </td>
                </tr>
              ) : (
                ledgerEntries.map((entry) => (
                  <tr key={entry.id}>
                    <td className="ps-3 text-nowrap">
                      {new Date(entry.created_at).toLocaleString('en-US', {
                        dateStyle: 'medium',
                        timeStyle: 'short',
                      })}
                    </td>
                    <td>
                      <span className="badge bg-info text-dark text-uppercase fw-semibold">
                        {entry.voucherType}
                      </span>
                    </td>
                    <td className="text-muted fw-mono small">
                      {entry.voucherNo}
                    </td>
                    <td className="text-end text-danger fw-semibold">
                      {entry.debit > 0 ? entry.debit.toFixed(2) : '-'}
                    </td>
                    <td className="text-end text-success fw-semibold">
                      {entry.credit > 0 ? entry.credit.toFixed(2) : '-'}
                    </td>
                    <td className={`text-end fw-bold pe-3 ${entry.runningBalance >= 0 ? 'text-dark' : 'text-danger'}`}>
                      {entry.runningBalance.toFixed(2)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LedgerDetails;